/// node输入内容并Command Enter时触发
export class NodeContentEnterMsg {
    constructor(nodeId) {
        this.nodeId = nodeId;
        this.naming = "NodeContentEnterMsg";
    }
}
